<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Geração de Recebíveis</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Gerar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formGerarRecebivel" ref="formGerarRecebivel" v-model="valid" lazy-validation >
                    <v-row v-if="parametro.doadorGrupoObrigatorio" dense>
                        <v-col cols="12" md="5">
                            <v-text-field v-model="item.mesAnoInicial" label="Mês/Ano Inicial" :rules="fieldRules" v-mask="mskMesAno" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2" class="body-1" align="center">
                            até
                        </v-col>
                        <v-col cols="12" md="5">
                            <v-text-field v-model="item.mesAnoFinal" label="Mês/Ano Final" :rules="fieldRules" v-mask="mskMesAno" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select v-model="item.regiaoId" label="Região/Grupo" :rules="fieldRules" :items="regioes" item-value="id" item-text="nome" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select v-model="item.bancoId" label="Banco" :items="bancos" item-value="id" item-text="nome" :rules="fieldRules" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row v-else dense>
                        <v-col cols="12" md="3">
                            <v-text-field v-model="item.mesAnoInicial" label="Mês/Ano Inicial" :rules="fieldRules" v-mask="mskMesAno" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="1" class="body-1" align="center">
                            até
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field v-model="item.mesAnoFinal" label="Mês/Ano Final" :rules="fieldRules" v-mask="mskMesAno" dense outlined/>
                        </v-col>                        
                        <v-col cols="12" md="5">
                            <v-select v-model="item.bancoId" label="Banco" :items="bancos" item-value="id" item-text="nome" :rules="fieldRules" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-textarea v-model="log" label="Log" :loading="isLoading" readonly dense outlined/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import RecebivelService from '@/core/services/financeiro/RecebivelService';
import BancoService from '@/core/services/financeiro/BancoService';
import { ParametroService } from '../../../core/services/geral';
import { RegiaoService } from '../../../core/services/doacao';
import { Parametro } from '../../../core/domain/geral';
import { Regiao } from '../../../core/domain/doacao';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            if ('formGerarRecebivel' in this.$refs){
                this.$refs.formGerarRecebivel.resetValidation();
                this.log = '';
            }
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (this.dialog) {
                this.Carregar();
            }
            else{
                this.$emit('fechou');                
            }
        }
    },
    data: () => ({
        service: new RecebivelService(),
        bancoService: new BancoService(),
        parametroService: new ParametroService(),
        parametro: new Parametro(),
        regiaoService: new RegiaoService(),
        regiao: new Regiao(),
        mskMesAno: process.env.VUE_APP_MSK_MESANO,
        valid: true,
        dialog: false,
        isLoading: false,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        bancos: [],
        log: '',
        salvando: false
    }),
    methods: {
        save() {
            if (this.$refs.formGerarRecebivel.validate()) {                
                this.salvando = true;
                this.log = '';
                this.isLoading = true;
                this.service.Gerar(this.item).then(
                    res => {
                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.$emit('salvou');
                        this.log = res.data;
                        this.valid = false;
                        this.isLoading = false;
                    }, 
                    err =>  {
                        if (err.response.status == 400) {
                            this.$swal('Aviso', err.response.data.title, 'warning');
                        }
                        else {
                            this.$swal('Aviso', err.response.data, 'error');
                        }

                        this.isLoading = false;
                    }
                ).finally(() => {
                    this.salvando = false;
                });

                //this.valid = false;
            }

        },
        Carregar(){
            this.parametroService.ObterPorId(1).then(
                res => {
                    this.parametro = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            )
            this.regiaoService.ListarTudo().then(
                res => {
                    this.regioes = res.data.items;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            )            
            this.bancoService.Listar().then(
                res => {
                    this.bancos = res.data.items;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );
        },
        close() {
            this.dialog = false;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    }
}
</script>